import {
  ANALYTICS_EVENT_CATEGORIES,
  ANALYTICS_EVENT_NAMES,
  trackEvent,
} from '@/src/packages/server/clients/analytics';
import { IProductSelectedOptions } from '@/src/packages/components/pages/Product/ProductContext';
import { Box } from '@/src/packages/components/ui/Box';
import { ProductOptionHeading } from '@/src/packages/components/pages/Product/ProductControls/ProductOptions/ProductOptionsOptionHeading';
import { ProductSizeSelector } from '@/src/packages/components/pages/Product/ProductControls/ProductOptions/ProductSizeSelector/ProductSizeSelector';
import { IFetchProductVariantSchema } from '@bitmap/contracts';
import { ProductOption, ProductOptionValue } from '@prisma/client';
import { IProductFormContext } from '@/src/packages/components/contexts/product-form.context';
import {
  SizeGuide,
  SizeGuides,
} from '@/src/packages/components/pages/SizeGuide';
import { useSizeGuideDrawerStore } from '@/src/packages/hooks/use-basket-drawer';

export const selectedOption = (
  options: IFetchProductVariantSchema['product']['options'],
  option: IFetchProductVariantSchema['product']['options'][0],
  selectedOptions: IProductSelectedOptions
) => {
  const selectedOptionId = selectedOptions.find(
    (opt) => opt.optionId === option.id
  )?.value;

  const optionFound = options.find((opt) => opt.id === option.id);

  return optionFound?.values.find((value) => value.id === selectedOptionId);
};

export const ProductSizeSelection = ({
  option,
  options,
  skus,
  handleSelectOption,
  selectedOptions,
}: {
  skus: IFetchProductVariantSchema['skus'];
  handleSelectOption(option: ProductOption, value: ProductOptionValue): void;
  selectedOptions: IProductFormContext['selectedOptions'];
  options: IFetchProductVariantSchema['product']['options'];
  option: IFetchProductVariantSchema['product']['options'][0];
}) => {
  const { handleOpen } = useSizeGuideDrawerStore();

  const handleClickSizeGuideLink = () => {
    trackEvent({
      name: ANALYTICS_EVENT_NAMES.CHECKOUT_APPLY_DISCOUNT_CODE,
      category: ANALYTICS_EVENT_CATEGORIES.PRODUCT_PAGE,
    });

    handleOpen();
  };

  const selected = selectedOption(options, option, selectedOptions);

  return (
    <Box>
      <ProductOptionHeading>
        Size:{' '}
        {selected && (
          <Box as="span" marginLeft={1} fontWeight="normal">
            {selected.name}
          </Box>
        )}
        <Box
          className="ml-auto transition-all duration-200 cursor-pointer"
          onClick={handleClickSizeGuideLink}
          color="weak"
          fontWeight="normal"
          hoverColor="strong"
        >
          Size guide
        </Box>
      </ProductOptionHeading>
      <ProductSizeSelector
        option={option}
        handleSelectOption={handleSelectOption}
        skus={skus}
        selectedOptions={selectedOptions}
      />
    </Box>
  );
};
